var amdi18n={"__root":{"WELCOME_TO_TREBBLE_FM":"Welcome To Trebble FM","TREBBLE_LET_YOU_LISTEN_TO":"Trebble FM lets you browse and discover content that talk about subjects that matter to you in a byte-size audio format we call \"content\".","SUBSCRIBE_TO_ANYTING_YOU_LIKE":"Subscribe to anything you like and you'll be able to enjoy it easily on your Amazon Alexa or your Google Assistant device."},"__fr":{"WELCOME_TO_TREBBLE_FM":"Bienvenue sur Trebble FM","TREBBLE_LET_YOU_LISTEN_TO":"Trebble FM vous permet de parcourir et de découvrir les chaînes qui traitent de sujets qui vous intéressent dans un format audio flash que nous appelons \"contenu\".","SUBSCRIBE_TO_ANYTING_YOU_LIKE":"Abonnez-vous à tout ce que vous voulez et vous pourrez en profiter facilement sur votre Amazon Alexa ou votre appareil Google Assistant."},"__en":{"WELCOME_TO_TREBBLE_FM":"Welcome To Trebble FM","TREBBLE_LET_YOU_LISTEN_TO":"Trebble FM lets you browse and discover content that talk about subjects that matter to you in a byte-size audio format we call \"content\".","SUBSCRIBE_TO_ANYTING_YOU_LIKE":"Subscribe to anything you like and you'll be able to enjoy it easily on your Amazon Alexa or your Google Assistant device."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;